import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveScheduleMutation = gql`
   mutation SaveSchedule(
      $schedule: ScheduleInput!
      $deletedClosedExceptionIds: [UInt!]!
      $hasDeletedClosedExceptions: Boolean = false
      $deletedScheduleHourIds: [UInt!]!
      $hasDeletedScheduleHours: Boolean = false
   ) {
      deleteScheduleDetails(ids: $deletedScheduleHourIds) @include(if: $hasDeletedScheduleHours)
      deleteClosedExceptions(ids: $deletedClosedExceptionIds) @include(if: $hasDeletedClosedExceptions)
      schedule: saveSchedule(schedule: $schedule) {
         scheduleId
         name
         description
         scheduleDetailsConnection {
            items {
               scheduleDetailId
               scheduleId
               dayOfWeek
               openTime
               closeTime
            }
         }
         closedExceptionsConnection {
            items {
               closedExceptionId
               scheduleId
               startDate
               endDate
               startTime
               endTime
               prompt {
                  promptId
                  name
               }
            }
         }
      }
   }
`;
